import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from "react-transition-group";

import styles from './style.css';
import Div100vh from "../../..//uq-ui/components/div-100";

class Select extends PureComponent {

  static defaultProps = {
    show: false,
    items: [],
    onItemSelect: () => {},
  };

  static propTypes = {
    show: PropTypes.bool,
    onItemSelect: PropTypes.func,
    selectedItem: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func
  };

  onItemPress = (value) => {
    this.props.onItemSelect(value);
  }
  renderItems() {
    const { items, selectedItem } = this.props;
    return items.map((value) => {
      if (value === selectedItem) {
        return (
          <div className={styles.selectedItemText} 
               onClick={this.onItemPress.bind(this, value)} 
               key={value}>
               {value}
          </div>
        );
      } else {
        return (
          <div className={styles.itemText} 
               onClick={this.onItemPress.bind(this, value)} 
               key={value}>
               {value}
          </div>
        );
      }
    });
  }

  render() {
    const { show, onClose } = this.props;
    return (
      <CSSTransition
          in={show}
          timeout={300}
          classNames="modalSlideUp"
          unmountOnExit
          mountOnEnter>
        <Div100vh onClick={onClose}
                  className={styles.overlay}>
          <div className={styles.container}>
            { this.renderItems() }
          </div>
        </Div100vh>
      </CSSTransition>
    );
  }
}

export default Select;